export const SET_FONT = "SET_FONT"
export const SET_DESIGN = "SET_DESIGN"
export const SET_COLOR_SCHEMA = "SET_COLOR_SHCEMA"
export const SET_HEADER_FOR_WEB_VIEW = "SET_HEADER_FOR_WEB_VIEW"
export const SET_PRE_LOGIN = "SET_PRE_LOGIN"
export const SET_HOME = "SET_HOME"
export const SET_SETTINGS = "SET_SETTINGS"